import { Pipe, PipeTransform } from '@angular/core';
import { GroupItem } from '@models/lookup';

@Pipe({
    name: 'groupItems',
    standalone: true,
})
export class GroupItemsPipe implements PipeTransform {
    transform(value: GroupItem[]): { name: string; items: GroupItem[] }[] {
        const groups: Record<string, GroupItem[]> = value.reduce(
            (acc, item) => {
                if (!acc[item.group]) {
                    acc[item.group] = [];
                }
                acc[item.group].push(item);
                return acc;
            },
            {} as Record<string, GroupItem[]>,
        );

        return Object.keys(groups).map((key) => ({
            name: key,
            items: groups[key],
        }));
    }
}
